export const businessRegistrationState = {
  businessRegistrationFormType: null,
 
};
